'use server'

import { apiRequest, ApiResponse } from '../request'

export type FinancialCategoryType = 'INCOME' | 'EXPENSE' | 'BOTH'

export interface FinancialCategoryItem {
    id: number
    name: string
    code: string | null
    type: FinancialCategoryType
    active: boolean
    parentId: number | null
    parent?: { id: number; name: string; code: string | null } | null
    children?: FinancialCategoryItem[]
    _count?: { children: number }
    companyId: number
    createdAt: string
    updatedAt: string
}

export interface CreateFinancialCategoryData {
    name: string
    type: FinancialCategoryType
    code?: string
    parentId?: number | null
}

export interface UpdateFinancialCategoryData extends Partial<CreateFinancialCategoryData> {
    active?: boolean
}

const BASE = 'financial/financial-categories'

export async function getFinancialCategories(params?: {
    type?: FinancialCategoryType
}): Promise<ApiResponse<FinancialCategoryItem[]>> {
    return apiRequest<FinancialCategoryItem[]>(BASE, { params: params || {} })
}

export async function getFinancialCategoryTree(params?: {
    type?: FinancialCategoryType
}): Promise<ApiResponse<FinancialCategoryItem[]>> {
    return apiRequest<FinancialCategoryItem[]>(`${BASE}/tree`, { params: params || {} })
}

export async function getFinancialCategoryChildren(parentId: number): Promise<ApiResponse<FinancialCategoryItem[]>> {
    return apiRequest<FinancialCategoryItem[]>(`${BASE}/children/${parentId}`, {})
}

export async function searchFinancialCategories(query: string, type?: FinancialCategoryType): Promise<ApiResponse<FinancialCategoryItem[]>> {
    const params: any = { q: query }
    if (type) params.type = type
    return apiRequest<FinancialCategoryItem[]>(`${BASE}/search`, { params })
}

export async function getFinancialCategoryNextCode(parentId?: number | null): Promise<ApiResponse<{ code: string }>> {
    const params: any = {}
    if (parentId) params.parentId = parentId
    return apiRequest<{ code: string }>(`${BASE}/next-code`, { params })
}

export async function getFinancialCategory(id: number): Promise<ApiResponse<FinancialCategoryItem>> {
    return apiRequest<FinancialCategoryItem>(`${BASE}/${id}`, {})
}

export async function createFinancialCategory(data: CreateFinancialCategoryData): Promise<ApiResponse<FinancialCategoryItem>> {
    return apiRequest<FinancialCategoryItem>(BASE, { data }, 'post')
}

export async function updateFinancialCategory(id: number, data: UpdateFinancialCategoryData): Promise<ApiResponse<FinancialCategoryItem>> {
    return apiRequest<FinancialCategoryItem>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteFinancialCategory(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}
